import moment from 'moment';
import { environment } from 'environments';

(() => {
  class ChargeMailOrderCompleteVisitController {
    constructor(
      $rootScope,
      $scope,
      $timeout,
      $interval,
      toastr,
      Orders,
      Users,
      $state,
      ngDialog,
      localStorageService,
      Utils,
      Constants,
    ) {
      'ngInject';

      Object.assign(this, {
        Date,
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        Orders,
        Users,
        $state,
        ngDialog,
        localStorageService,
        Utils,
        Constants,
        visit: $scope.ngDialogData.visit,
        newMailorderPrescriptionsArray: $scope.ngDialogData.newMailorderPrescriptionsArray,
        recurring_discount_amount: 0,
        show_recurring: false,
        recurring_discount_amount_as_num: false,
        timezone: $rootScope.timezones[0].timezone,
        BOD_2718: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_2801: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      });
      this.pimsParameters = this.localStorageService.get('pimsParameters');
      this.skip_refill_api_calls = false;
      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.skip_refill_api_calls
      )
        this.skip_refill_api_calls = true;
      this.numPrescriptions = this.newMailorderPrescriptionsArray.length;

      if (this.skip_refill_api_calls) {
        this.newMailorderPrescriptionsArray.forEach(prescription => {
          prescription.medName = prescription.code;
        });
        this.getMailOrderPayment();
      } else {
        this.newMailorderPrescriptionsArray.forEach(prescription => {
          prescription.mailorderFlag = false; // WE WILL KEEP "refillDate" AS DATE WITHOUT TIME
          // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE
          // if (this.visit.order_lines[0].pharmacy_option.fulfilment_type === 3) {
          //   var fill_date = prescription.mail_order.fill_requests[0].fill_date.split("-");
          //   prescription.refillDate = new Date(parseInt(fill_date[0]), parseInt(fill_date[1])-1, parseInt(fill_date[2]));
          //   prescription.refillDate.setHours(0,0,0,0);
          // } else {

          prescription.refillDate = new Date(); //   prescription.refillDate.setHours(0,0,0,0);
          // }

          prescription.medName = prescription.code;
          prescription.messageStatus = [];
          prescription.messageStatus.push(
            {
              id: 0,
              value: false,
              name: 'One Time',
            },
            {
              id: 1,
              value: true,
              name: 'Auto Delivery',
            },
          );

          if (this.BOD_2718) {
            if (this.isNonPrescriptionMed(prescription)) {
              prescription.showMessageStatus = 'One Time';
            } else {
              if (prescription.mail_order.auto_refill) {
                prescription.showMessageStatus = 'Auto Delivery';
              } else {
                prescription.showMessageStatus = 'One Time';
              }
            }
          } else {
            if (prescription.mail_order.auto_refill) {
              prescription.showMessageStatus = 'Auto Delivery';
            } else {
              prescription.showMessageStatus = 'One Time';
            }
          }

          if (!this.isNonPrescriptionMed(prescription)) {
            prescription.mail_order_original = angular.copy(prescription.mail_order);
          }

          prescription.fillCharged = [
            {
              id: '1',
              name: '1 fill',
            },
          ];
          prescription.fillSent = [
            {
              id: '1',
              name: '1 fill',
            },
          ];
          prescription.noOfRefillCharged = '1'; // Orders.TOTALFILLS[0].id => "1"

          prescription.noOfRefillSent = '1'; // Orders.TOTALFILLS[0].id => "1"

          this.getMailOrderPayment();
        });
      }
    }

    isNonPrescriptionMed(prescription) {
      return prescription.charge_type_id === 4 && prescription.mail_order === null;
    }

    hasAnyAutoDelivery() {
      return this.newMailorderPrescriptionsArray.some(
        p => p.showMessageStatus === 'Auto Delivery' && !this.isNonPrescriptionMed(p),
      );
    }

    applyPromo(amount, { skipFlat = false } = {}) {
      let new_amount = amount;

      if (this.visit.fee.promo_code && this.visit.fee.promo_code.id && this.visit.fee.promo_code.discount) {
        if (this.visit.fee.promo_code.discount.type == 'percent') {
          let new_discount = this.visit.fee.promo_code.discount.value * amount;
          new_amount = amount - new_discount;
          if (new_amount < 0) new_amount = 0;
          // BODACDC-3326: for bundles, skip applying flat discount per-medication here;
          // it will be distributed proportionally by applyFlatPromoToBundle (BODACDC-3332) instead.
        } else if (!skipFlat) {
          let new_discount = this.visit.fee.promo_code.discount.value;
          new_amount = amount - new_discount;
          if (new_amount < 0) new_amount = 0;
        }
      }

      return new_amount;
    }

    applyFlatPromoToBundle(prescriptions) {
      const promo = this.visit.fee.promo_code;
      if (!promo?.id || !promo?.discount || promo.discount.type === 'percent') return;

      const flatDiscount = promo.discount.value;
      const totalFee = prescriptions.reduce((sum, p) => sum + p.medicationFee, 0);
      if (totalFee <= 0) return;

      let remainingDiscount = flatDiscount;
      prescriptions.forEach((prescription, index) => {
        const isLast = index === prescriptions.length - 1;
        const discount = isLast
          ? remainingDiscount
          : Math.floor((prescription.medicationFee / totalFee) * flatDiscount * 100) / 100;
        if (!isLast) {
          remainingDiscount = Math.round((remainingDiscount - discount) * 100) / 100;
        }
        // Ensure we don't end up with negative medication fee due to rounding
        prescription.medicationFee = Math.max(0, prescription.medicationFee - discount);
      });
    }

    getMailOrderPayment() {
      this.medicationFeeTotal = 0;
      this.discount_active = false;
      this.totalMedicationFee = 0;
      this.medicationFeeTotalBeforeDiscount = 0;

      if (this.skip_refill_api_calls) {
        this.newMailorderPrescriptionsArray.forEach(prescription => {
          prescription.medicationFee = prescription.dispense_amount * prescription.unit_price;
          const skipFlat = this.newMailorderPrescriptionsArray.length > 1;
          prescription.medicationFee = this.applyPromo(prescription.medicationFee, { skipFlat });
          this.medicationFeeTotalBeforeDiscount = this.medicationFeeTotalBeforeDiscount + prescription.medicationFee;
        });
        // BODACDC-3332: distribute flat discount across bundle medications proportionally by price,
        // flooring each share to 2dp and giving the remainder to the last medication.
        if (this.newMailorderPrescriptionsArray.length > 1) {
          this.applyFlatPromoToBundle(this.newMailorderPrescriptionsArray);
          this.medicationFeeTotalBeforeDiscount = this.newMailorderPrescriptionsArray.reduce(
            (sum, p) => sum + p.medicationFee,
            0,
          );
        }
        // BODACDC-3326: total is already correct from per-medication discount above; skip re-applying to the total.
        this.medicationFeeTotal = this.medicationFeeTotalBeforeDiscount;
        this.medicationFeeTotalOriginal = angular.copy(this.medicationFeeTotal);
      } else {
        this.newMailorderPrescriptionsArray.forEach(prescription => {
          if (this.BOD_2718) {
            var medication_amount_after_discount = prescription.mail_order?.fill_requests[0]
              .medication_amount_after_discount
              ? prescription.mail_order.fill_requests[0].medication_amount_after_discount
              : 0;
            var medication_amount_before_discount = prescription.mail_order?.fill_requests[0]
              .medication_amount_before_discount
              ? prescription.mail_order.fill_requests[0].medication_amount_before_discount
              : 0;
          } else {
            var medication_amount_after_discount = prescription.mail_order.fill_requests[0]
              .medication_amount_after_discount
              ? prescription.mail_order.fill_requests[0].medication_amount_after_discount
              : 0;
            var medication_amount_before_discount = prescription.mail_order.fill_requests[0]
              .medication_amount_before_discount
              ? prescription.mail_order.fill_requests[0].medication_amount_before_discount
              : 0;
          }

          if (medication_amount_after_discount < medication_amount_before_discount && !this.recurring_discount_amount) {
            this.discount_active = true;
            prescription.medicationFee =
              prescription.mail_order.fill_requests[0].medication_amount_before_discount *
                prescription.noOfRefillCharged -
              (prescription.mail_order.fill_requests[0].medication_amount_before_discount -
                prescription.mail_order.fill_requests[0].medication_amount_after_discount);
          } else if (this.recurring_discount_amount) {
            prescription.totalMedicationFee =
              prescription.dispense_amount * prescription.unit_price * prescription.noOfRefillCharged;
            var recurring_discount_amount = '' + this.recurring_discount_amount;
            recurring_discount_amount = recurring_discount_amount.replace('£', '');
            if (!recurring_discount_amount) recurring_discount_amount = '0';
            this.total_recurring_discount_amount =
              prescription.totalMedicationFee - prescription.noOfRefillCharged * parseFloat(recurring_discount_amount);

            if (parseFloat(recurring_discount_amount) > 0) {
              this.recurring_discount_amount_as_num = true;
            } else {
              if (medication_amount_after_discount < medication_amount_before_discount) {
                this.discount_active = true;
                prescription.medicationFee =
                  prescription.mail_order.fill_requests[0].medication_amount_before_discount *
                    prescription.noOfRefillCharged -
                  (prescription.mail_order.fill_requests[0].medication_amount_before_discount -
                    prescription.mail_order.fill_requests[0].medication_amount_after_discount);
              }

              this.recurring_discount_amount_as_num = false;
            }
          } else {
            prescription.medicationFee =
              prescription.dispense_amount * prescription.unit_price * prescription.noOfRefillCharged;
          }
          const skipFlat = this.newMailorderPrescriptionsArray.length > 1;
          prescription.medicationFee = this.applyPromo(prescription.medicationFee, { skipFlat });
          this.medicationFeeTotal = this.medicationFeeTotal + prescription.medicationFee;
        });
        // BODACDC-3332: distribute flat discount across bundle medications proportionally by price,
        // flooring each share to 2dp and giving the remainder to the last medication.
        if (this.newMailorderPrescriptionsArray.length > 1) {
          this.applyFlatPromoToBundle(this.newMailorderPrescriptionsArray);
          this.medicationFeeTotal = this.newMailorderPrescriptionsArray.reduce((sum, p) => sum + p.medicationFee, 0);
        }
        this.medicationFeeTotalOriginal = angular.copy(this.medicationFeeTotal);
      }
    }

    close() {
      this.$scope.closeThisDialog(false);
    }

    getButtonLabel() {
      if (this.skip_refill_api_calls) return 'Charge patient';
      return 'Charge patient & send fill request';
    }

    proceed() {
      this.medicationCharge();
    }

    medicationChargeSkippingRefills() {
      var this2 = this;
      if (!this2.numPrescriptions) return;
      let medicationFeeTotal = this2.medicationFeeTotal; // TO CONVERT TO STRING

      medicationFeeTotal = '' + medicationFeeTotal;
      medicationFeeTotal = medicationFeeTotal.replace('£', '');
      if (!medicationFeeTotal) medicationFeeTotal = '0';

      if (isNaN(medicationFeeTotal)) {
        this2.toastr.warning('The amount should be a number.');
        return;
      }

      let chargeData = {
        amount: parseFloat(medicationFeeTotal),
      };
      this2.processing = true;
      this2.Orders.chargeMedication(this2.visit.id, chargeData)
        .then(({ data }) => {
          this2.processing = false;
          this2.toastr.success('Payment was successful.');
          var parameters = {
            dollar_sign: false,
            pill_sign: true,
            new_prescription: true,
            show_prescriber: true,
            include_icon_url: true,
          }; // this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);

          this2.$scope.closeThisDialog(true);
        })
        .catch(err => {
          this2.processing = false;

          if (err.status === 400 || err.status === 409) {
            this2.toastr.error('Error processing payment: ' + err.data.message.summary);
          } else {
            this2.toastr.error('Error processing payment: ' + err.status + ' - ' + err.message);
          }

          var parameters = {
            dollar_sign: true,
            pill_sign: false,
            new_prescription: true,
            show_prescriber: true,
            include_icon_url: true,
          }; // this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);
        });
    }

    medicationCharge() {
      if (!this.numPrescriptions) return;
      var validation = true;
      this.newMailorderPrescriptionsArray.forEach(prescription => {
        if (parseInt(prescription.noOfRefillSent) < parseInt(prescription.noOfRefillCharged)) {
          validation = false;
        }
      });

      if (!validation) {
        this.toastr.error('Some number of refills to send are less than the number of refills to be charged ');
        return;
      }

      var daysValid = true;
      this.newMailorderPrescriptionsArray.forEach(prescription => {
        if (this.isNonPrescriptionMed(prescription)) return;
        if (prescription.showMessageStatus === 'Auto Delivery') {
          const days = parseInt(prescription.mail_order.days_between_refills, 10);
          if (!days || days < 1 || days > 365) {
            daysValid = false;
          }
        }
      });
      if (!daysValid) {
        this.toastr.error('Please enter how many days between refills');
        return;
      }

      var medicationFeeTotal = '' + this.medicationFeeTotal;
      var recurring_discount_amount = '' + this.recurring_discount_amount;
      recurring_discount_amount = recurring_discount_amount.replace('£', '');
      if (!recurring_discount_amount) recurring_discount_amount = '0';
      recurring_discount_amount = parseFloat(recurring_discount_amount);
      medicationFeeTotal = medicationFeeTotal.replace('£', '');
      if (!medicationFeeTotal) medicationFeeTotal = '0';
      medicationFeeTotal = parseFloat(medicationFeeTotal);

      if (this.newMailorderPrescriptionsArray.length > 1 && medicationFeeTotal !== this.medicationFeeTotalOriginal) {
        this.callConfirmDiscountModal(this.discount_active, this.newMailorderPrescriptionsArray, response => {
          if (response) {
            this.newMailorderPrescriptionsArray = angular.copy(response.newMailorderPrescriptionsArray);
            this.medicationFeeTotal = response.medicationFeeTotal;
            this.processing = true;
            this.anyFillPaymentFailed = false;
            this.scheduledNonMedPrescriptions = [];
            this.paymentResults = { medSuccess: 0, medFailed: 0, nonMedSuccess: 0, nonMedFailed: 0 };
            this.processFill(0);
          } else {
            // Do nothing
            // If user closes the popup
          }
        });
      } else {
        this.processing = true;
        this.anyFillPaymentFailed = false;
        this.scheduledNonMedPrescriptions = [];
        this.paymentResults = { medSuccess: 0, medFailed: 0, nonMedSuccess: 0, nonMedFailed: 0 };
        this.processFill(0);
      }
    }

    processFill(index) {
      if (index + 1 <= this.numPrescriptions) {
        var prescription = this.newMailorderPrescriptionsArray[index];
        this.updateDaysBetweenRefillsIfChanged(prescription)
          .then(() => this.processFillPromise(prescription))
          .then(() => {
            if (this.isNonPrescriptionMed(prescription)) {
              this.paymentResults.nonMedSuccess++;
            } else {
              this.paymentResults.medSuccess++;
            }
          })
          .catch(err => {
            if (this.isNonPrescriptionMed(prescription)) {
              this.paymentResults.nonMedFailed++;
            } else {
              this.paymentResults.medFailed++;
            }
          })
          .finally(() => {
            this.processFill(index + 1);
          });
      } else {
        // ALL DONE
        // If any fill failed, also show a red toast for every nonmed that was only
        // "scheduled" (info toast) — those payments won't be taken either.
        if (
          this.anyFillPaymentFailed &&
          this.scheduledNonMedPrescriptions &&
          this.scheduledNonMedPrescriptions.length
        ) {
          this.scheduledNonMedPrescriptions.forEach(prescription => {
            const medText = ' for ' + prescription.medName;
            this.toastr.error("Medication payment didn't go through. Credit card is declined" + medText + '.');
          });
        }
        this.processing = false;
        const hasFailures = this.paymentResults.medFailed > 0 || this.paymentResults.nonMedFailed > 0;
        if (hasFailures) {
          // this.callRejectModal(() => {
          this.$scope.closeThisDialog({ status: 'paymentFailed', results: this.paymentResults });
          // });
        } else {
          this.$scope.closeThisDialog(true);
        }
      }
    }

    processFillPromise(prescription) {
      var this2 = this;
      return new Promise((resolve, reject) => {
        var medText = ' for ' + prescription.medName; // WE WILL KEEP "refillDate" AS DATE WITHOUT TIME
        // ALSO THE "DATE PICKER" IS RETURNING A DATE TYPE
        // prescription.refillDate.setHours(0,0,0,0);

        prescription.refill_Date = moment(prescription.refillDate).toISOString();
        var medicationFee;
        var recurring_discount_amount = this.recurring_discount_amount;
        var totalMedicationFee = prescription.totalMedicationFee;
        var chargeFutureRefills = false;

        if (this.newMailorderPrescriptionsArray.length > 1) {
          medicationFee = this.BOD_2801
            ? this.Utils.parseAmount(prescription.medicationFee)
            : prescription.medicationFee;
        } else {
          medicationFee = this.BOD_2801 ? this.Utils.parseAmount(this.medicationFeeTotal) : this.medicationFeeTotal;
        }

        if (isNaN(medicationFee)) {
          medicationFee = medicationFee.replace('£', '');
        }

        if (isNaN(recurring_discount_amount)) {
          recurring_discount_amount = recurring_discount_amount.replace('£', '');
        }

        if (parseFloat(recurring_discount_amount) > 0) {
          chargeFutureRefills = true;
          prescription.chargeData = {
            amount: totalMedicationFee,
            recurring_discount_amount: parseFloat(recurring_discount_amount),
          };
        } else {
          prescription.chargeData = {
            amount: medicationFee,
          };
        }

        if (chargeFutureRefills && !(moment().format('YYYY-MM-DD') >= prescription.refill_Date)) {
          var fillDetail = {
            fill_date: this2.Utils.formatDateToISO(prescription.refill_Date, this2.timezone),
            num_to_charge: parseInt(prescription.noOfRefillCharged),
            num_to_send: parseInt(prescription.noOfRefillSent),
            recurring_discount_amount: parseFloat(recurring_discount_amount),
            amount: totalMedicationFee,
          };
        } else {
          var fillDetail = {
            fill_date: this2.Utils.formatDateToISO(prescription.refill_Date, this2.timezone),
            num_to_charge: parseInt(prescription.noOfRefillCharged),
            num_to_send: parseInt(prescription.noOfRefillSent),
          };
        }

        prescription.messageStatus.forEach(m => {
          if (m.name === prescription.showMessageStatus) {
            prescription.mailorderFlag = m.value;
          }
        });
        var mailorderType = {
          auto_refill: prescription.mailorderFlag,
        };
        if (this.BOD_2718) {
          //not a fan of the return statement but resolve doesn't exit a function ...
          //... and don't want to wrap everything in a feature flag around the bottom code too.
          if (this.isNonPrescriptionMed(prescription)) {
            this.Orders.nonMedPayment(this.visit.id, prescription.chargeData)
              .then(data => {
                // Show blue info toast: non-med payment scheduled/processed successfully
                this2.toastr.info('Non-medication payment scheduled' + medText + '.');
                // Track this prescription so we can show a red toast if a later med payment fails
                if (!this2.scheduledNonMedPrescriptions) this2.scheduledNonMedPrescriptions = [];
                this2.scheduledNonMedPrescriptions.push(prescription);
                var parameters = {
                  dollar_sign: false,
                  pill_sign: true,
                  new_prescription: true,
                  show_prescriber: true,
                  include_icon_url: true,
                };
                this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);
                resolve();
              })
              .catch(err => {
                // Non-med payment failed — clear message, no undefined
                const summary = err && err.data && err.data.message && err.data.message.summary;
                const errMsg = summary || 'Payment processing failed.';
                this2.toastr.error('Non-medication payment failed' + medText + ': ' + errMsg);
                var parameters = {
                  dollar_sign: true,
                  pill_sign: false,
                  new_prescription: true,
                  show_prescriber: true,
                  include_icon_url: true,
                };
                this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);
                reject(err);
              });
            return;
          }
        }

        const mail_order_id = prescription.mail_order.id;
        const fill_id = prescription.mail_order.fill_requests[0].id;
        const status = prescription.mail_order.fill_requests[0].status.toUpperCase();

        this.Orders.updateMailorderDeliveryType(mail_order_id, mailorderType)
          .then(({ data }) => {
            this2.Orders.updateMailorderFill(mail_order_id, fill_id, fillDetail)
              .then(({ data }) => {
                var today = moment().toISOString();
                var today_UK_timezone = this2.Utils.formatDateToISO(today, this2.timezone);
                var refill_Date_UK_timezone = this2.Utils.formatDateToISO(prescription.refill_Date, this2.timezone); // We compare both dates in UK timezone

                if (today_UK_timezone >= refill_Date_UK_timezone) {
                  this2.Orders.mailorderFillPayment(mail_order_id, fill_id, prescription.chargeData)
                    .then(({ data }) => {
                      this2.toastr.success('Payment was successful' + medText + '.');
                      var parameters = {
                        dollar_sign: false,
                        pill_sign: true,
                        new_prescription: true,
                        show_prescriber: true,
                        include_icon_url: true,
                      };
                      this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);
                      resolve();
                    })
                    .catch(err => {
                      var is_medication_charge_already_taken = false;

                      if (err.status === 400) {
                        is_medication_charge_already_taken = true;
                        const summary400 = err.data && err.data.message && err.data.message.summary;
                        this2.toastr.error((summary400 || 'Payment processing failed.') + medText);
                      } else if (err.status === 409) {
                        // Red toast per medication with clear declined message
                        this2.toastr.error(
                          "Medication payment didn't go through. Your credit card is declined" + medText,
                        );
                      } else {
                        this2.toastr.error(
                          'Error processing payment' + medText + ': ' + err.status + ' - ' + err.message,
                        );
                      }

                      // Also show a red toast for any nonmed that was only "scheduled" —
                      // those payments won't be taken since this med payment failed.
                      if (this2.scheduledNonMedPrescriptions && this2.scheduledNonMedPrescriptions.length) {
                        this2.scheduledNonMedPrescriptions.forEach(scheduledPrescription => {
                          const scheduledMedText = ' for ' + scheduledPrescription.medName;
                          this2.toastr.error(
                            "Non-medication payment didn't go through. Credit card is declined" +
                              scheduledMedText +
                              '.',
                          );
                        });
                        // Clear so they don't fire again in processFill ALL DONE
                        this2.scheduledNonMedPrescriptions = [];
                      }

                      var parameters = {
                        dollar_sign: true,
                        pill_sign: false,
                        new_prescription: true,
                        show_prescriber: true,
                        include_icon_url: true,
                      };
                      this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);

                      if (
                        is_medication_charge_already_taken &&
                        this2.visit.admin_status != this2.Constants.AdminStatuses.Complete.NumericValue
                      ) {
                        resolve();
                      } else {
                        reject(err);
                      }
                    });
                } else {
                  this2.toastr.success(
                    'Payment and Fill Request will be processed on ' + prescription.refill_Date + medText + '.',
                  );
                  var parameters = {
                    dollar_sign: false,
                    pill_sign: true,
                    new_prescription: true,
                    show_prescriber: true,
                    include_icon_url: true,
                  };
                  this2.Orders.callSlackToNotify(prescription, parameters, this2.visit);
                  resolve();
                }
              })
              .catch(err => {
                this2.toastr.error('Error updating the mailorder fills' + medText + ': ' + err.data.message.summary);
                reject(err);
              });
          })
          .catch(err => {
            this2.toastr.error(
              'Error updating the mailorder auto refill setting' + medText + ': ' + err.data.message.summary,
            );
            reject(err);
          });
      });
    }

    updateDaysBetweenRefillsIfChanged(prescription) {
      return new Promise((resolve, reject) => {
        if (this.isNonPrescriptionMed(prescription)) {
          resolve();
          return;
        }
        const isAutoDelivery = prescription.showMessageStatus === 'Auto Delivery';
        if (!isAutoDelivery) {
          resolve();
          return;
        }
        const daysBetween = parseInt(prescription.mail_order.days_between_refills, 10);
        const originalDays = parseInt(prescription.mail_order_original.days_between_refills, 10);
        const daysBetweenChanged = daysBetween !== originalDays;
        if (!daysBetweenChanged) {
          resolve();
          return;
        }
        const mail_order_id = prescription.mail_order.id;
        const refillInfo = {
          auto_refill: prescription.mail_order_original.auto_refill,
          refills_remaining: parseInt(prescription.mail_order.refills_remaining, 10),
          days_between_refills: daysBetween,
        };
        this.Orders.updateRefillInfo(mail_order_id, refillInfo)
          .then(() => resolve())
          .catch(err => reject(err));
      });
    }

    callRejectModal(callback) {
      return this.ngDialog.open({
        templateUrl: 'app/components/reject-mailorder-completevisit/reject-mailorder-completevisit.html',
        // To not allow the user closes the modal without explicitely to have some action
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'RejectMailOrderCompleteVisitController',
        controllerAs: 'reject',
        data: {
          message: 'Medications payment failed.',
        },

        preCloseCallback(res) {
          if (res === true) {
            return callback(true);
          }

          return callback(false);
        },
      });
    }

    callConfirmDiscountModal(discount_active, newMailorderPrescriptionsArray, callback) {
      return this.ngDialog.open({
        templateUrl: 'app/components/confirm-discount-completevisit/confirm-discount-completevisit.html',
        // To not allow the user closes the modal without explicitely to have some action
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'ConfirmDiscountCompleteVisitController',
        controllerAs: 'discount',
        data: {
          newMailorderPrescriptionsArray,
          discount_active,
        },

        preCloseCallback(discountArray) {
          return callback(discountArray);
        },
      });
    }
  }

  ChargeMailOrderCompleteVisitController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    'toastr',
    'Orders',
    'Users',
    '$state',
    'ngDialog',
    'localStorageService',
    'Utils',
    'Constants',
  ];
  angular.module('pims').controller('ChargeMailOrderCompleteVisitController', ChargeMailOrderCompleteVisitController);
})();
